import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, radius, shadow, layout, mq } = theme.custom;
    const toneRule = (tone: 'success' | 'danger' | 'warning' | 'info') => ({
        borderLeftColor: color.tone[tone].main,
        '& $icon': { color: color.tone[tone].main },
    });
    return {
        notifications: {
            position: 'fixed',
            top: layout.headerHeight + 12,
            right: 16,
            width: 360,
            maxWidth: 'calc(100vw - 32px)',
            zIndex: 1400,
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            pointerEvents: 'none',
            [mq.sm]: { top: layout.headerHeight + 8, right: 8, left: 8, width: 'auto', maxWidth: 'none' },
            '& .success': toneRule('success'),
            '& .error': toneRule('danger'),
            '& .warning': toneRule('warning'),
            '& .info': toneRule('info'),
        },
        '@keyframes toast': {
            '0%': { opacity: 0, transform: 'translateY(-6px)' },
            '8%': { opacity: 1, transform: 'translateY(0)' },
            '92%': { opacity: 1, transform: 'translateY(0)' },
            '100%': { opacity: 0, transform: 'translateY(-6px)' },
        },
        wpapper: {
            pointerEvents: 'auto',
            display: 'flex',
            alignItems: 'flex-start',
            gap: 10,
            padding: '12px 40px 12px 14px',
            borderRadius: radius.md,
            backgroundColor: color.surfaceRaised,
            border: `1px solid ${color.border}`,
            borderLeft: `3px solid ${color.border}`,
            boxShadow: shadow.lg,
            color: color.text.primary,
            fontSize: 14,
            lineHeight: 1.4,
            position: 'relative',
            overflowWrap: 'anywhere',
            opacity: 0,
            animation: '$toast 10s 1',
            animationFillMode: 'forwards',
            animationTimingFunction: 'ease-out',
        },
        icon: { display: 'flex', flexShrink: 0, marginTop: 1, '& svg': { fontSize: 20 } },
        text: { flex: 1, minWidth: 0, paddingTop: 1 },
        close: {
            position: 'absolute',
            top: 6,
            right: 6,
            color: color.text.secondary,
        },
    };
});
